module.exports = __webpack_public_path__ + "img/service_type_code.4f7913bd.png";